import InputGroup from './InputGroup';
import './InputGroup.scss';

export default InputGroup;
